import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

const AddRetailerModal = ({ show, handleClose, onSubmitData }) => {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = (data) => {
    onSubmitData(data);
    reset();
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Retailer</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>

          <Form.Group controlId="bussinessOwnerName" className="mb-3">
            <Form.Label>Business Owner Name</Form.Label>
            <Form.Control
              {...register("bussinessOwnerName", { required: true })}
              placeholder="Enter business owner name"
            />
            {errors.bussinessOwnerName && <small className="text-danger">Required</small>}
          </Form.Group>

          <Form.Group controlId="bussinessName" className="mb-3">
            <Form.Label>Business Name</Form.Label>
            <Form.Control
              {...register("bussinessName", { required: true })}
              placeholder="Enter business name"
            />
            {errors.bussinessName && <small className="text-danger">Required</small>}
          </Form.Group>

          <Form.Group controlId="indetificationNumber" className="mb-3">
            <Form.Label>Identification Number</Form.Label>
            <Form.Control
              {...register("indetificationNumber", { required: true })}
              placeholder="Enter ID Number"
            />
            {errors.indetificationNumber && <small className="text-danger">Required</small>}
          </Form.Group>

          <Form.Group controlId="kra_Pin" className="mb-3">
            <Form.Label>KRA PIN</Form.Label>
            <Form.Control
              {...register("kra_Pin", { required: true })}
              placeholder="Enter KRA PIN"
            />
            {errors.kra_Pin && <small className="text-danger">Required</small>}
          </Form.Group>

          <Form.Group controlId="contactPerson" className="mb-3">
            <Form.Label>Contact Person</Form.Label>
            <Form.Control
              {...register("contactPerson", { required: true })}
              placeholder="Enter contact person"
            />
            {errors.contactPerson && <small className="text-danger">Required</small>}
          </Form.Group>

          <Form.Group controlId="phoneNumber" className="mb-3">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              {...register("phoneNumber", { required: true })}
              placeholder="Enter phone number"
            />
            {errors.phoneNumber && <small className="text-danger">Required</small>}
          </Form.Group>

          <Form.Group controlId="email" className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              {...register("email", { required: true })}
              placeholder="Enter email"
            />
            {errors.email && <small className="text-danger">Enter a valid email</small>}
          </Form.Group>

          <Form.Group controlId="userCode" className="mb-3">
            <Form.Label>User Code</Form.Label>
            <Form.Control
              {...register("userCode", { required: true })}
              placeholder="Enter user code"
            />
            {errors.userCode && <small className="text-danger">Required</small>}
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Add Retailer
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddRetailerModal;
